import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        runGuardsAndResolvers: 'always',
        loadChildren: () => import('./tabs/tabs.routes').then((m) => m.routes),
      },
];
